import styled from 'styled-components';

import { colors, fontSizes, spacing } from 'ui/theme';

import { useFiltersContext } from '../../../contexts';
import { useColumns } from '../../../../components/table';

export const displayText = {
  noMessageTypes: 'There are no message types for this message channel.',
  noMatches: 'No matching message types.',
};

const Wrapper = styled.div`
  grid-column: 1 / span ${() => useColumns().length};
  color: ${colors.textSecondary};
  font-size: ${fontSizes.s14};
  padding: ${spacing.base} ${spacing.double};
`;

export const NoMessageTypes = () => {
  const { clearFilters, search } = useFiltersContext();
  const isUsingFilters = !!clearFilters || !!search.length;
  return (
    <Wrapper data-test="no-message-types">
      {isUsingFilters ? displayText.noMatches : displayText.noMessageTypes}
    </Wrapper>
  );
};
